// extracted by mini-css-extract-plugin
export default {"grid-action":"GridAction_grid-action__ZUijY"};